<div id="_amk_" class="font-bold ism-gold text-2">
  {{myPageName}} works!
</div>

